//
// Copyright (c) 2008-2025 Barry E. Mapen All Rights Reserved
//
import { useContext } from 'react';
import classNames from 'classnames';
import ReactPropTypes from 'prop-types';

import { FormContext } from './Form';

import * as patch from './PatchFunctions';

export function Checkbox({
    name,
    id,
    checked,
    className = "",
    disabled = false,
    readOnly = false,
    title = "",
    onChange,
    ...rest
}) {


    const { 
        initial, current, formId, formDisabled, formReadOnly, defaultOnChange,
    } = useContext(FormContext);

    // Extract the initial value for this named item in the form fields
    const initValue = patch.getPath(initial, name);

    // Use any parameters pass into this field
    const currId = id ? id : `${name}-${formId}`;
    const currValue = checked ? checked : patch.getPath(current, name);
    const currDisabled = disabled || formDisabled;
    const currReadOnly = readOnly || formReadOnly;

    const checkClass = classNames(
        'form-check',
        className,
        { 'is-dirty': currValue !== initValue }
    );

    //console.log(`ID=${idRef.current} name=${name} checked=${checked}`);

    return(
        <div className={checkClass}>
            <input 
                className={`form-check-input`}
                type={'checkbox'}
                name={name}
                id={currId}
                checked={!!currValue}
                onChange={(e) => defaultOnChange(e, onChange)}
                disabled={currDisabled}
                readOnly={currReadOnly}
                {...rest}
            />
            <label 
                htmlFor={currId}
                className='form-check-label'
            >
                {title}
            </label>
        </div>
    );
}

Checkbox.propTypes = {
    name: ReactPropTypes.string.isRequired,
    type: ReactPropTypes.string,
    value: ReactPropTypes.any,
    onChange: ReactPropTypes.func,
    required: ReactPropTypes.bool,
    disabled: ReactPropTypes.bool,
}

